import { apiClient } from "@/services/api"
import { defineStore } from "pinia"

/**
 * The packet form's tabs, as the hashes they appear in the URL as. Read by `LewPacketEdit` and by the
 * command palette's tab catalogue (`entityTabItems`), so a retyped hash cannot drift between the two.
 */
export const PACKET_FORM_NAMES = {
  GENERAL: "general",
  ACTIVITY: "activity",
}

const _blankPacket = () => {
  return {
    id: "",
    name: "",
    items: [],
    type: "",
    createdAt: null,
    createdBy: null,
    lastModifiedAt: null,
    lastModifiedBy: null,
  }
}

export const usePacketStore = defineStore("packet", {
  state: () => ({
    packet: _blankPacket(),
  }),
  getters: {
    getPacket: state => state.packet,
  },
  actions: {
    setPacket(packet) {
      this.packet = packet
    },
    clearPacket() {
      this.packet = _blankPacket()
    },
    updatePacket(packet) {
      return apiClient
        .put(`/packet/${packet.id}`, packet, { headers: { tenant: true, authorization: true } })
        .then(res => {
          if (res.status === 200) {
            this.setPacket(res.data)
          }
          return res
        })
    },
    createPacket(packet) {
      return apiClient.post("/packet", packet, { headers: { tenant: true, authorization: true } }).then(res => {
        if (res.status === 200) {
          this.setPacket(res.data)
        }
        return res
      })
    },
    loadPacket(id) {
      return apiClient.get(`/packet/${id}`, { headers: { tenant: true, authorization: true } }).then(res => {
        if (res.status === 200) {
          this.setPacket(res.data)
        }
        return res
      })
    },
    // A list page for a catalogue's overview, which keeps its own rows (`useCatalogOverviewRows`).
    loadPackets({ page, search, sortBy, sortDesc, selected, itemsPerPage, type, referenceType, referenceId }) {
      return apiClient.get("/packet", {
        params: {
          page: page,
          search: search,
          sortBy: sortBy,
          sortDesc: sortDesc,
          selected: selected,
          itemsPerPage: itemsPerPage,
          // One catalogue's packets (`MATERIAL`, `MACHINE`, `ADDITIONAL_EFFORT`); every type when unset.
          type: type,
          // The "only packets that point at this record" narrowing an overview arrives with.
          // Undefined when there is none, and axios drops undefined params.
          referenceType: referenceType,
          referenceId: referenceId,
        },
        headers: { tenant: true, authorization: true },
      })
    },
    deletePacket(id) {
      return apiClient
        .delete(`/packet/${id}`, {
          headers: { tenant: true, authorization: true },
        })
        .then(res => {
          if (res.status === 200) {
            this.clearPacket()
          }
        })
    },
  },
})
